import { ApiError } from '@/api/client'
import { failureMessage } from '@/apps/core/utils'
import { translate } from '@/apps/core/plugins/i18n'

/**
 * What a failed billing call says: the sentence of its code in the reader's language, or the
 * screen's `fallback` — and, when the server gave one, the reference to quote to support, since a
 * question about money is answered from that request's trace.
 */
export function billingFailure(error: unknown, fallback: string): string {
  const message = failureMessage(error, fallback)
  return error instanceof ApiError && error.requestId
    ? `${message} (${translate('billing.topUp.failed.requestId', { id: error.requestId })})`
    : message
}
